/* User defined models */
import { BatteryConfig } from './batteryConfig.model';
import { Exam } from './exam.model';


export class ExamSet {
  id: string;
  attributes: any;
  exams: Exam[];
  batteryConfig: BatteryConfig;

  constructor(id: string, attributes: any, exams: Exam[]) {
    this.id = id;
    this.attributes = attributes;
    this.exams = exams;

    if (!!attributes.b2b && attributes.b2b.bufferTime > 0) {
      this.batteryConfig = new BatteryConfig(attributes.b2b.bufferTime, attributes.b2b.maxDuration);
    }
  }

  public get selectedAll() {
    return this.exams.every(e => e.isSelected);
  }

  public get indeterminate() {
    return !this.selectedAll && this.exams.some(e => e.isSelected);
  }
}
